import { Component } from '@angular/core';
import { ApplicantService } from '@core/services/auth-user/applicant.service';
import { LinkService } from '@core/services/link.service';
import { ClientUserService } from '@features/client-user/client-user.service';
import { YCModalComponent } from '@yourcause/common/modals';
import { AuthService } from '../../services/auth.service';
import { PortalDeterminationService } from '../../services/portal-determination.service';

@Component({
  selector: 'yc-terms-of-service-modal',
  templateUrl: './terms-of-service-modal.component.html'
})
export class TermsOfServiceModalComponent extends YCModalComponent<boolean> {

  constructor (
    private authService: AuthService,
    private determinationService: PortalDeterminationService,
    private clientUserService: ClientUserService,
    private applicantService: ApplicantService,
    private linkService: LinkService
  ) {
    super();
  }

  async onSubmit () {
    await this.authService.acceptTermsOfService();
    if (this.determinationService.isManager) {
      await this.clientUserService.getUser(true);
    } else {
      await this.applicantService.getApplicant(true);
    }
    this.closeModal.emit(true);
  }

  openPrivacyPolicy () {
    window.open(this.linkService.getPrivacyPolicyLink(), '_blank');
  }

  openTermsOfService () {
    window.open(this.linkService.getTermsOfServiceLink(), '_blank');
  }

  onCancel () {
    this.closeModal.emit(false);
  }
}
